// src/metrics/events.ts

/** Каноничные имена событий (исправлены опечатки) */
export const METRIC_EVENTS = {
  auth_main: 'auth_main',
  auth_enter: 'auth_enter',
  auth_success: 'auth_success',

  registration_main: 'registration_main',
  registration_enter: 'registration_enter',
  registration_success: 'registration_success',

  forgot_pass: 'forgot_pass',

  main_menu_chapter_button: 'main_menu_chapter_button',

  test_agree: 'test_agree',
  test_screen: 'test_screen',
  test_start: 'test_start',
  test_completed: 'test_completed',
  test_update: 'test_update',
  test_retry_screen: 'test_retry_screen',
  test_retry_click: 'test_retry_click',
  test_question_answer: 'test_question_answer',
  l4u_decryption: 'l4u_decryption',
  l4u_doc_consult: 'l4u_doc_consult',

  my_health_chapter_choose: 'my_health_chapter_choose', // was: my_health_chapter_chose
  my_health_bucket_confirm: 'my_health_bucket_confirm',

  profile_main: 'profile_main',
  logout_button: 'logout_button', // was: logout_buttom

  main_page: 'main_page',
  contacts_page: 'contacts_page',

  qa_block: 'qa_block',
  qa_question_open: 'qa_question_open',

  my_health_video_open: 'my_health_video_open',
  my_health_recipe_open: 'my_health_recipe_open',

  error_screen_alert: 'error_screen_alert', // was: error_screen_allert

  my_health_checkbox_click: 'my_health_checkbox_click',
  tg_bot_click: 'tg_bot_click',
} as const;

export type MetricEventName = (typeof METRIC_EVENTS)[keyof typeof METRIC_EVENTS];

/** Алиасы для обратной совместимости со старыми именами */
export const LEGACY_EVENT_ALIASES: Record<string, MetricEventName> = {
  my_health_chapter_chose: METRIC_EVENTS.my_health_chapter_choose,
  logout_buttom: METRIC_EVENTS.logout_button,
  error_screen_allert: METRIC_EVENTS.error_screen_alert,
};

export const METRIC_EVENTS_TRIGGERS = {
  main: 'main',
  header: 'header',
  footer: 'footer',
  sidebar: 'sidebar',
  profile: 'profile',
  signup: 'signup',
  signin: 'signin',
  forgotPassword: 'forgotPassword',
  forgotPasswordVerifyEmail: 'forgotPasswordVerifyEmail',
  resetPassword: 'resetPassword',
  possibilities: 'possibilities',
  myHealth: 'myHealth',
  myAnalysis: 'myAnalysis',
  myPlan: 'myPlan',
  myTraining: 'myTraining',
  myNutrition: 'myNutrition',
  myVitamins: 'myVitamins',
  myStatistics: 'myStatistics',
  mySkinAnalysis: 'mySkinAnalysis',
};
